import React, { Component } from 'react';

class Services extends Component {
    render() {
        return (
          <section className="page services">
            <div id="featuredImage" className="featuredImage bgServices"></div>
            <h1 className="title">Service</h1>
              <ul className="content">
              <li>
                  Die ERB-Kauf GmbH erwirbt von einzelnen oder allen Erben einer Erbengemeinschaft deren Erbteile.
              </li>
              <li>
                Hierzu unterbreiten wir Ihnen ein Angebot, dass sich finanziell an den Chancen und Risiken jedes individuellen Nachlassfalles orientiert.
              </li>
              <li>
                Die Übertragung der Erbanteile wird von einem Notar beurkundet. Dieses Erfordernis bietet höchstmögliche Sicherheit und Transparenz. Die Kosten hierfür werden von uns übernommen.
              </li>
              <li>   
                Nach Unterzeichnung der Erbteilübertragung erhalten Sie unmittelbar den vereinbarten Kaufpreis. Sie können finanziell sofort von der Erbschaft profitieren und vermeiden Verzögerungen von leider oft mehreren Jahren, die bei der Erbnachweisführung und der Auseinandersetzung des Nachlasses anfallen können.
              </li> 
              <li>   
                Alle Risiken und Lasten gehen auf die ERB-Kauf GmbH über.
              </li>  
              </ul>
          </section>
        );
    }
}

export default Services;


// WEBPACK FOOTER //
// ./src/pages/Services.js